export default {
    membership_management: {
        no_membership_number: 'Schließen Sie Ihr erstes Investment ab, um Mitglied werden zu können.',
        membership_number: 'Mitgliedsnummer',
        download_document: 'Mitgliedsdokument herunterladen',
        send_document: 'Formular per Post erhalten',
        send_document_requested: 'Dokumentsendung angefordert',
        send_document_sent: 'Dokument wurde gesendet',
        document_label: 'Mitgliedsdokument',
        order_certificates: 'Bestell Urkunde',
    },
    account_dropdown_log_out: 'Ausloggen',
    account_dropdown_company_account: 'Firmenkonto',
    account_dropdown_tooltip_account: 'Investorenkonto',
    account_dropdown_tooltip_fill_account_data: 'Bitte vervollständigen Sie Ihre Investorendaten',
    account_dropdown_tooltip_orders: 'Order',
    account_dropdown_tooltip_wallets: 'Wallet',
    personal_account: 'Kontoübersicht',
    welcome: 'Willkommen',
    header_new_investor: 'Neuer Investor?',
    header_register: 'Registrieren',
    header_sign_in: 'Einloggen',
    header_unfinished_investment_process: 'Sie haben einen Auftrag in Bearbeitung',
    email_verification_already_verified: 'Ihre E-Mail Adresse wurde bereits bestätigt',
    email_verification_email_pending_missmatch:
        'Die E-Mail Adresse konnte nicht verifiziert werden. Es wurde in der Zwischenzeit eine andere E-Mail Verifikation gestartet. Bitte versuchen Sie es erneut.',
    email_verification_expired_link: 'Der Bestätigungslink ist abgelaufen.',
    email_verification_verified: 'Ihre E-Mail Adresse wurde erfolgreich geändert!',
    create_company_profile_question: 'Wollen Sie zu Ihrem Konto einen Firmenaccount eröffnen?',
    create_company_profile: 'Firmenaccount anlegen',
    language_switcher_select_language: 'Sprache wählen',
    discard: 'Abbrechen',
    header: {
        sign_in: 'Einloggen',
        register: 'Registrieren',
        new_to_invest: 'Neuer Investor?',
    },
    kyc_provider: {
        idnow: 'IDNow',
        signteq: 'Signteq',
    },
    pay_via_eth: 'Via ETH zahlen',
    gas_limit: 'Gas Preis',
    address_to_send_eth: 'Empfängeradresse für ETH',
    pay_via_eth_desc:
        'Bezahlen per ETH-Beschreibung: Wenn Sie für Ihre Zahlung die Banküberweisung als Option nutzen, fällt eine zusätzliche Gebühr an, die sich nach Ihrem Gesamtinvestitionsbetrag richtet. Zusätzliche Gebühr für die Überweisung Ihrer Investition.',
    portfolio_size: 'Portfolio-Größe',
    view_details: 'Details anzeigen',
    date: 'Datum',
    time: 'Zeit',
    total: 'Gesamt',
    investment: 'Investition',
    investment_amount: 'Investitionsbetrag',
    support_amount: 'Unterstützungsbetrag',
    order_status_canceled: 'Storniert',
    order_status_pending: 'Ausstehend',
    order_status_paid: 'Bezahlt',
    order_status_approved: 'Bestätigt',
    order_status_covered: 'Covered',
    order_status_accepted: 'Accepted',
    my_orders_side: 'Meine Orders',
    no_order: 'Keine Order',
    order_voucher_amount: 'Betrag vom Voucher',
    order_discount_voucher_amount: 'Betrag von Gutscheincode',
    order_wallet_amount: 'Betrag vom Wallet',
    success: '',
    error: '',
    copy: '',
    save: '',
    copy_to_clipboard: '',
    copied_to_clipboard: '',
    errors: {
        validation_error: '',
        general_error: '',
        kyc_id_required: 'KYC ist erforderlich, um mit der Investition fortzufahren',
        kyc_bank_required: 'Bankverifizierung ist erforderlich, um mit der Investition fortzufahren',
        kyc_address_required: 'Adressverifizierung ist erforderlich, um mit der Investition fortzufahren',
        kyc_tax_required: 'Steuerverifizierung ist erforderlich, um mit der Investition fortzufahren',
    },
    terms_link: '',
    privacy_link: '',
    admin_email: '',
    contact_support: '',
    investment_process: {
        close: 'Schließen',
        cancel: 'Abbrechen',
        pay_now: 'Jetzt bezahlen',
        payment_processing:
            'Ihre Zahlung wird verarbeitet. Folgen Sie den Anweisungen im Fenster des Zahlungsanbieters. Bitte schließen Sie dieses Fenster nicht.',
        payment_successful: 'Zahlung erfolgreich.',
        payment_failed: 'Zahlung fehlgeschlagen.',
        try_again: 'Nochmal versuchen',
        prepaid_payment_successful:
            'Ihre Zahlung ist in Bearbeitung. Der Status ihres Investments wird nach erfolgreichem Zahlungseingang aktualisiert.',
        accept_savings_plan: 'Ansparplan',
        accept_gift_membership: 'Mitgliedschaft schenkung',
        visit_faq_url: 'Für mehr info klicken Sie hier',
        emission_agio_text: '',
        emission_disagio_text: '',
        sign_digitally: '',
        signature: 'Zeichnung',
        confirm_signature: 'Zeichnung abschließen',
        reset_verification_header: 'Wir müssen Ihre Verifizierung zurücksetzen',
        // prettier-ignore
        reset_verification_body:
            'Da Sie sich noch über unseren früheren Partner IDnow verifiziert haben, ist eine neue Verifizierung über Signteq erforderlich, bevor Sie investieren können.<br><br>' +
            'Bitte wenden Sie sich per E-Mail an <a href="mailto:support{\'@\'}conda-capital.com">support{\'@\'}conda-capital.com</a>, um den Verifizierungsprozess zurücksetzen zu lassen.',
        signature_legal_notice: '',
        modal_reset_verification_header: '',
        modal_reset_verification_body: '',
        modal_reset_verification_button: '',
        signature_legal_notice_title: '',
        nyala_vault: '',
        or: '',
        download_signature_document: '',
        signature_document: 'Zeichnungsdokument',
        law_requirements: '',
        summary: '',
        payment: '',
        contract_period: '',
        issuer: 'Emittent',
        minimum_investment: '',
        steps: '',
        next: '',
        back: '',
        time_left: '',
        to_the_landing_page: '',
        thank_you_for_you_investment: '',
        pay_via_bank_transfer_header: '',
        pay_via_bank_transfer_description: '',
        go_to_my_orders: '',
        please_accept_all_documents: '',
        please_accept_all_disclaimers: '',
        please_accept_all_warnings: '',
        wallet_retrievable_balance: 'Verfügbarer Betrag auf Wallet',
        voucher_available_balance: 'Verfügbarer Betrag auf Voucher',
        update_wallet_amount: 'Wallet-Guthaben anpassen',
        apply_wallet_amount: 'Wallet-Guthaben aktivieren',
        update_voucher_amount: 'Voucher-Guthaben anpassen',
        apply_voucher_amount: 'Voucher-Guthaben aktivieren',
        discount_code_applied_successfully: 'Gutscheincode erfolgreich aktiviert',
        discount_code_higher_than_amount:
            'Gutscheincode kann nicht angewendet werden, da der Rabatt höher als der Restbetrag ist.',
        available: 'verfügbar',
        discount_code: 'Gutscheincode',
        apply_discount_button: 'Aktivieren',
        activate_balance: '',
        public_name_consent: '',
        disclaimers: '',
        understand_all_risks: '',
        contract_documents: '',
        accept_all_documents: '',
        accept_all_warnings: '',
        investment_warnings: '',
        investment_warnings_description: '',
        pre_contractual_cooling_off_period: '',
        pre_contractual_cooling_off_period_description: '',
        incentives: '',
        incentive: '',
        selected_incentive: '',
        select_incentive: '',
        which_contract_type: '',
        voucher_title: '',
        voucher_description: '',
        cash_title: '',
        cash_description: '',
        enter_investment_amount: '',
        min_amount: '',
        max_amount: '',
        step_level: '',
        invest: '',
        enter_investment_pieces: '',
        emission_pieces_to_amount: '',
        emission_amount_to_pieces: '',
        investment_summary: '',
        investment_amount: '',
        wallet_amount: 'Wallet Guthaben',
        wallet_amount_description:
            'Wählen Sie bitte den Betrag aus den sie mit ihrem bestehenden Wallet-Guthaben decken möchten',
        voucher_amount: '',
        voucher_amount_description:
            'Wählen Sie bitte den gewünschten Voucher und den Betrag aus, den sie aktivieren möchten.',
        expires_at: 'Läuft ab am',
        contract_type: '',
        amount_to_pay: '',
        registration_number: '',
        address: '',
        invest_as_natural_profile: '',
        invest_as_legal_profile: '',
        invest_in: '',
        create_order: '',
        payment_account_holder_default: '',
        pay_via_credit_card_header: '',
        pay_via_credit_card_description: '',
        pay_via_credit_card_button: '',
        verification_outstanding: '',
        verification_outstanding_description: '',
        verify_button: 'Jetzt Verifizieren',
        broker: '',
        broker_id: '',
        please_provide_broker_id: '',
        please_confirm: '',
        please_confirm_your_details: '',
        please_fill_required_fields: '',
        note: 'note',
        email_must_match_profile:
            'Die eingegebene E-Mail Adresse stimmt nicht mit Ihrer Profil-E-Mail Adresse überein.',
        first_name_must_match_profile: 'Der eingegebene Vorname stimmt nicht mit Ihrem Profil-Vorname überein.',
        last_name_must_match_profile: 'Der eingegebene Nachname stimmt nicht mit Ihrem Profil-Nachname überein.',
        ecsp: {
            not_enough_experience_title: '',
            not_enough_experience_description: '',
            not_enough_risk_acknowledgements_title: '',
            not_enough_risk_acknowledgements_description: '',
            investment_too_high_title: '',
            investment_too_high_description: '',
        },
        altfg: {
            investment_process_altfg_notice: '',
            investment_process_altfg_choice_notice: '',
            investment_process_altfg_professional_investor: '',
            investment_process_altfg_legal_entity: '',
            investment_process_altfg_maximum_net_income: '',
            investment_process_altfg_maximum_assets: '',
        },
        vermanlg: {
            personal_data_verification_note:
                'Bitte stellen Sie sicher, dass die eingegebenen Daten buchstabengetreu exakt (inklusive Punkt und Komma) mit Ihren persönlichen Daten übereinstimmen. Andernfalls erscheint die Fehlermeldung „Daten unvollständig“. Überprüfen Sie in diesem Fall die Übereinstimmung erneut.',
            vib_investor_from_germany: '',
            investments_information_sheet: '',
            vib_current_location: '',
            vib_date: '',
            vib_email: '',
            vib_first_name: '',
            vib_last_name: '',
            vib_place_of_birth: '',
            vib_date_of_birth: '',
            vib_id_card_passport_number: '',
            issuing_authority: '',
            vib_address: '',
            vib_postal_code: '',
            vib_city: '',
            vib_state: '',
            vib_tax_number: '',
            vib_investment_information: '',
            vib_investment_under_1000: '',
            vib_investment_financial_assets_over_10000: '',
            vib_investment_income_over_1k: '',
            vib_investment_income_over_10k: '',
            vib_investment_limit_part_1: '',
            vib_investment_limit_part_2: '',
            vermanlg_confirm_section_note:
                'Bitte verwenden Sie die gleichen Angaben wie in Ihrem Investorenprofil! Alle Felder sind erforderlich.',
            vermanlg_right_of_withdrawal: '',
            vermanlg_right_of_withdrawal_disclaimer: '',
            vermanlg_consequences_of_revocation: '',
            vermanlg_consequences_of_revocation_disclaimer: '',
        },
        stock_price: 'Anteilspreis',
    },
    forms: {
        select_option: '',
        radio_no: '',
        radio_yes: '',
        radio_male: '',
        radio_female: '',
        day: '',
        month: '',
        year: '',
        dd: '',
        mm: '',
        yyyy: '',
    },
    account: {
        investor_account: '',
        my_profile: '',
        first_name: '',
        last_name: '',
        save: '',
        date_of_birth: '',
        nationality: '',
        address: '',
        postal_code: '',
        city: '',
        same_as_residential: '',
        country_of_birth: '',
        city_of_birth: '',
        // prettier-ignore
        esac_locked_account_info:
            'Um Ihr Profil oder Ihre KYC-Informationen und -Dokumente zu ändern oder zu aktualisieren, wenden Sie sich bitte per E-Mail an das ESAC-Team unter platform{\'@\'}superangels.club.',
        phone_number: '',
        iban: '',
        bic: '',
        social_security_number: '',
        tax_number: '',
        mobile_number: '',
        current_email: '',
        email_pending: '',
        new_email: '',
        email_address: '',
        country: '',
        state: '',
        gender: '',
        gender_placeholder: '',
        pep: '',
        pep_past: '',
        pep_position: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        saved_kyc_successfully_message: '',
        average_investment_transaction_amount: '',
        average_investment_transactions_per_year: '',
        investment_transactions: '',

        experience_share: '',
        experience_bond: '',
        experience_participation_paper: '',
        experience_crypto_currency: '',
        experience_unsecured_junior_debt: '',
        knowledge_share: '',
        knowledge_bond: '',
        knowledge_participation_paper: '',
        knowledge_crypto_currency: '',
        knowledge_unsecured_junior_debt: '',

        experience_with_securities: '',
        experience_without_advice: '',
        experience_with_asset_management: '',
        experience_with_investment_advice: '',

        bonds: '',
        stocks: '',
        market_funds: '',
        investment_funds: '',
        experience_investment_forms: '',
        current_occupation: '',
        highest_educational_attainment: '',
        default_language: 'Standardsprache',
    },
    portfolio: {
        investments_total: '',
        open_investments: '',
        my_investments: '',
        no_investments_to_show: '',
        orders: {
            order_status: '',
            order_status_active: '',
            order_status_completed: '',
            order_status_canceled: '',
            order_status_pending: '',
            order_status_paid: '',
            order_status_approved: '',
            order_status_covered: '',
            order_status_accepted: '',
        },
    },
    investment_targets: {
        investment_objectives: 'Ihre Investitionsziele',
        // prettier-ignore
        legal_investment_objectives: 'Investitionsziele der Gesellschaft',
        security_coverage: 'Pensionsplan',
        security_coverage_or_pension_plan: 'Sicherheitsabdeckung der Entschädigungszahlung oder Pensionsplan',
        pension_provision: 'Pensionsversorgung',
        retention_of_assets: 'Rückhalt von Vermögenswerten',
        distribution_of_assets: 'Verteilung von Vermögenswerten',
        capital_gain: 'Kapitalgewinn',
        investment_horizon: 'Ihre Investitionshorizont',
        // prettier-ignore
        legal_investment_horizon: 'Investitionshorizont der Gesellschaft',
        investment_frequency:
            'Häufigkeit Ihrer Investition in alternative Vermögenswerte (einschließlich Venture Capital und Private Equity)',
        // prettier-ignore
        legal_investment_frequency:
            'Häufigkeit der Investition der Gesellschaft in alternative Vermögenswerte (einschließlich Venture Capital und Private Equity):',
    },
    financial_conditions: {
        financial_assets: 'Finanzielle Vermögenswerte (in EUR)',
        annual_operating_result: 'Jahresüberschuss (in EUR)',
        dept_capital: 'Schuldenkapital (in EUR)',
        properties: 'Eigentum an Immobilien',
        source_of_funds:
            'Quelle der Finanzierung (dies ist die Ursprung der spezifischen Finanzierung, die Sie investieren werden)',
        dividends_or_profits: 'Dividenden oder Gewinne aus Investitionen',
        lottery_gambling: 'Lotterie/Glücksspiel',
        divorce: 'Scheidung',
        maturity_or_surrender: 'Fälligkeit oder Rückgabe der Lebensversicherungspolice',
        gift: 'Geschenk',
        inheritance: 'Erbrecht',
        insurance_claims: 'Versicherungsleistungen',
        sale_of_property: 'Verkauf von Immobilien',
        savings: 'Sparkonten',
        loan: 'Kredit',
        other: 'Sonstiges',
        industry: 'Branche Ihrer Haupttätigkeit und/oder Ihrer Tätigkeit:',
        // prettier-ignore
        business_industry: 'Sektor der Haupttätigkeit der Gesellschaft:',
        dividends_or_profits_legal: 'Dividenden oder Gewinne aus Haltungen/Investitionen/Vermögenswerten',
        retained_earnings: 'Gehaltene Gewinne',
    },
    fatca_declaration: {
        cannot_continue: 'Leider können Sie den KYC-Prozess online nicht abschließen.',
        financial_institutions_under_fatca:
            'FATCA-Klassifizierung der Gesellschaft: Ist die Gesellschaft eine Finanzinstitution (FI) nach FATCA?',
        // prettier-ignore
        contact_support: 'Bitte kontaktieren Sie Venionaire unter platform{\'@\'}superangels.club.',
        us_citizen_or_resident: 'Sind Sie ein US-Bürger und/oder wohnen Sie in den USA für Steuerzwecke?',
        non_financial_entity_reason:
            'Bitte wählen Sie eine der folgenden Kategorien als zu welchem Typ der NFE der Investor (Rechtsform) ist',
        financial_institution_category: 'Finanzinstitute nach FATCA: Bitte wählen Sie eine der folgenden Kategorien:',
        us_entity: 'Ist die Gesellschaft eine US-Person nach FATCA-Vorschriften?',
        provide_giin: 'Können Sie den GIIN des registrierten Halters für FATCA-Zwecke bereitstellen',
        no_giin_reason:
            'Wenn die Gesellschaft eine Finanzinstitution ist, aber keinen GIIN ausstellen kann, bitte wählen Sie eine der folgenden Gründe:',
        giin: 'Bitte geben Sie den GIIN der Gesellschaft für FATCA-Zwecke an:',
        giin_sponsor_name: 'Name des Sponsors',
        giin_sponsor: 'GIIN des Sponsors',
    },
    crs_classification: {
        company_classification: 'CRS-Klassifizierung der Gesellschaft:',
        stock_exchange_name:
            'Bitte geben Sie den Namen des etablierten Börsenplatzes an, an dem die Aktien der Gesellschaft regelmäßig gehandelt werden:',
        affiliate_stock_exchange_name:
            'Oder wenn Sie ein Zusammenhangsunternehmen einer Gesellschaft haben, die regelmäßig an einem etablierten Börsenplatz gehandelt wird, bitte geben Sie den Namen des etablierten Börsenplatzes und das Unternehmen an:',
    },
    country_tax_residencies: {
        add_another_tax_residence: 'Weitere Steuerresidenz hinzufügen',
        cant_obtain_tin: 'Ich kann keinen TIN erhalten',
        tax_situation: 'Ihre Steuerlage',
        tax_residency: 'Steuerresidenz',
        capital_gains: 'Kapitalertragsteuerbefreiung (KESt)',
        foreign_assets_ownership: 'Eigentum an ausländischen Vermögenswerten',
        foreign_assets: 'Ausländische Vermögenswerte',
        capital_gains_legal: 'Kapitalertragsteuerbefreiung (KESt)',
        corporate_tax_exemption: 'Körperschaftsteuerbefreiung (KÖSt)',
        group_taxation: 'Gruppenbesteuerung',
    },
    legal_acknowledgements: {
        risks_acknowledgement:
            'Ich/wir erklären, dass Venionaire Ventures S.à r.l. (“VV”) keine Anfrage für die Erwerbung von Fondsanteilen in jedem Fall akzeptieren wird, wenn keine Informationen zur Risikobereitschaft bereitgestellt werden. Darüber hinaus erklären wir, dass neben den aufgeführten Risiken Schwankungen im Wert auftreten können, die aufgrund von Währungsumschichten (einschließlich Inflation) entstehen.',
        // prettier-ignore
        anti_money_laundering:
            'Gemäß dem geänderten Gesetz zur Bekämpfung der Geldwäsche und der Terrorismusfinanzierung vom 12. November 2004 erkläre(n) ich/wir, dass die offengelegten wirtschaftlich Berechtigten (UBO) die letztlich wirtschaftlich Berechtigten des Investors sind und verpflichte(n) mich/uns, den Wirtschaftsprüfer von VV über jede Änderung in der Beteiligungsstruktur, den Stimmrechten oder den wirtschaftlich Berechtigten des Investors zu informieren. Ich/wir erkläre(n) ferner, dass die Herkunft der für die Geschäftstätigkeit des Investors verwendeten Mittel und Wertpapiere nicht gegen das genannte Gesetz verstößt. Schließlich erkläre(n) ich/wir, dass auch die beabsichtigte Verwendung der aus diesen Geschäften stammenden Vermögenswerte nicht gegen dieses Gesetz verstoßen wird.',
        authorised_signatory:
            'Ich/wir bestätigen, dass wir die autorisierten Unterzeichner(n) des Investors sind und erklären, dass es gemäß Artikel 5 des Luxemburger CRS-Gesetzes verpflichtend ist, Fragen zu den offengelegten Informationen über die Steuer-Selbstauskunft zu beantworten.',
        tax_authorities:
            'Insbesondere erklären wir und stimmen zu, dass die offengelegten Informationen an die Luxemburger Steuerbehörden oder andere bevollmächtigte Vertreter unter Luxemburger Recht gemäß den Informationen, die für Finanzkonten erforderlich sind (siehe Anhang I, Abschnitt I des Gesetzes " Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", hierinafter "Luxembourg CRS Law") in Bezug auf den Investor oder seine endgültigen wesentlichen Eigentümer und jeden meldepflichtigen Register gemeldet werden können. Darüber hinaus erklären und stimmen wir zu, dass die offengelegten Informationen mit den Steuerbehörden der Länder ausgetauscht werden können, in denen wir und/oder der Investor eine Steuerresidenz haben, gemäß den intergouvernementalen Steuerdatenaustauschabkommen.',
        intergovernmental_tax_exchange:
            'Ich/wir autorisieren VV, alle offengelegten Informationen weiterzuleiten/auszutauschen, sowie die Informationen, die für die Meldung gemäß den intergouvernementalen Steuerdatenaustauschabkommen erforderlich sind, wie oben beschrieben, mit den zuständigen Steuerbehörden der Länder oder Länder.',
        notify_about_changes:
            'Ich/wir verpflichten uns, VV innerhalb von 30 Tagen über Änderungen, die sich auf die Selbstauskunft und die bereitgestellten Informationen auszahlen, zu benachrichtigen, und VV mit einer entsprechend aktualisierten Selbstauskunft ohne Verzögerung und ohne Anfrage zu versorgen. Ich/wir haben auf Anfrage Zugang zu den Daten über mich/uns/den Investor/die UBO(s), die an die Luxemburger Steuerbehörden weitergegeben werden und die personenbezogenen Daten korrigieren können. Die erhobenen Daten werden nicht länger als für die Zwecke des Luxemburger CRS-Gesetzes erforderlich gespeichert.',
        information_correct_and_complete:
            'Ich/wir erklären, dass alle von mir/uns angegebenen Informationen korrekt und vollständig sind, soweit ich/wir dies in unserem Wissen und Glauben glauben.',
    },
    acknowledgements: {
        check_all: 'Alle auswählen',
        currency_change_risk:
            'Ich/wir erklären, dass Venionaire Ventures S.à r.l. (“VV”) keine Anfrage für die Erwerbung von Fondsanteilen in jedem Fall akzeptieren wird, wenn keine Informationen zur Risikobereitschaft bereitgestellt werden. Darüber hinaus erklären wir, dass neben den aufgeführten Risiken Schwankungen im Wert auftreten können, die aufgrund von Währungsumschichten (einschließlich Inflation) entstehen.',
        own_account:
            'Ich/wir bestätigen, dass wir die autorisierten Unterzeichner(n) des Investors sind und erklären, dass es gemäß Artikel 5 des Luxemburger CRS-Gesetzes verpflichtend ist, Fragen zu den offengelegten Informationen über die Steuer-Selbstauskunft zu beantworten.',
        // prettier-ignore
        anti_money_laundering:
            'Gemäß dem geänderten Gesetz zur Bekämpfung der Geldwäsche und der Terrorismusfinanzierung vom 12. November 2004 erkläre(n) ich/wir, dass die offengelegten wirtschaftlich Berechtigten (UBO) die letztlich wirtschaftlich Berechtigten des Investors sind und verpflichte(n) mich/uns, den Wirtschaftsprüger von VV über jede Änderung in der Beteiligungsstruktur, den Stimmrechten oder den wirtschaftlich Berechtigten des Investors zu informieren. Ich/wir erkläre(n) ferner, dass die Herkunft der für die Geschäftstätigkeit des Investors verwendeten Mittel und Wertpapiere nicht gegen das genannte Gesetz verstößt. Schließlich erkläre(n) ich/wir, dass auch die beabsichtigte Verwendung der aus diesen Geschäften stammenden Vermögenswerte nicht gegen dieses Gesetz verstoßen wird.',
        self_certification_form:
            'Insbesondere erklären wir und stimmen zu, dass die offengelegten Informationen an die Luxemburger Steuerbehörden oder andere bevollmächtigte Vertreter unter Luxemburger Recht gemäß den Informationen, die für Finanzkonten erforderlich sind (siehe Anhang I, Abschnitt I des Gesetzes " Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", hierinafter "Luxembourg CRS Law") in Bezug auf den Investor oder seine endgültigen wesentlichen Eigentümer und jeden meldepflichtigen Register gemeldet werden können. Darüber hinaus erklären und stimmen wir zu, dass die offengelegten Informationen mit den Steuerbehörden der Länder ausgetauscht werden können, in denen wir und/oder der Investor eine Steuerresidenz haben, gemäß den intergouvernementalen Steuerdatenaustauschabkommen.',
        tax_data_exchange_agreement:
            'Ich/wir autorisieren VV, alle offengelegten Informationen weiterzuleiten/auszutauschen, sowie die Informationen, die für die Meldung gemäß den intergouvernementalen Steuerdatenaustauschabkommen erforderlich sind, wie oben beschrieben, mit den zuständigen Steuerbehörden der Länder oder Länder.',
        report_changes:
            'Ich/wir verpflichten uns, VV innerhalb von 30 Tagen über Änderungen, die sich auf die Selbstauskunft und die bereitgestellten Informationen auszahlen, zu benachrichtigen, und VV mit einer entsprechend aktualisierten Selbstauskunft ohne Verzögerung und ohne Anfrage zu versorgen. Ich/wir haben auf Anfrage Zugang zu den Daten über mich/uns/den Investor/die UBO(s), die an die Luxemburger Steuerbehörden weitergegeben werden und die personenbezogenen Daten korrigieren können. Die erhobenen Daten werden nicht länger als für die Zwecke des Luxemburger CRS-Gesetzes erforderlich gespeichert.',
        complete_and_correct_information:
            'Ich/wir erklären, dass alle von mir/uns angegebenen Informationen korrekt und vollständig sind, soweit ich/wir dies in unserem Wissen und Glauben glauben.',
    },
    experience_and_knowledge: {
        experience: 'Investitionserfahrung',
        knowledge: 'Wissen',
        stocks_equity_funds: 'Aktien, Aktienfonds',
        mixed_funds_etfs: 'Gemischte Fonds, ETFs',
        bonds_bond_funds: 'Anleihen, Anleihenfonds',
        closed_ended_funds: 'Geschlossene Fonds',
        options_other_derivatives: 'Optionen, andere Derivate',
        venture_capital: 'Venture Capital',
        other_shares_loans_in_private_companies: 'Andere Aktien/Kredite in Privatunternehmen',
        other_alternative_investments: 'Andere alternative Investitionen (Hedge-Fonds, Rohstofffonds, etc.)',
        follow_market_prices_business_financial_news:
            'Wie oft überprüfen Sie Marktpreise, Geschäftsnachrichten und Finanznachrichten?',
    },
    follow_market_options: {
        regularly: 'regelmäßig',
        occasionally: 'manchmal',
        rarely: 'selten',
        not_at_all: 'gar nicht',
    },
    investment_knowledge: {
        advanced: 'Fortgeschritten',
        basic: 'Grundlegend',
        none: 'Keine',
    },
    investment_horizon: {
        short_term: 'Kurzfristig (< 5 Jahre)',
        medium_term: 'Mittelfristig (5-10 Jahre)',
        long_term: 'Langfristig (11-20 Jahre)',
        very_long_term: 'Sehr langfristig (> 20 Jahre)',
    },
    investment_frequency: {
        one_off: 'Einmalig',
        monthly: 'Monatlich',
        quarterly: 'Vierteljährlich',
        semi_annually: 'halbjährlich',
        annually: 'jährlich',
    },
    risk_tolerance: {
        label: 'Ihre Risikobereitschaft ist:',
        // prettier-ignore
        label_legal: 'Risikobereitschaft des Investors (Rechtsform):',
        low: 'Niedrig',
        medium: 'Mittel',
        advanced: 'Fortgeschritten',
        high: 'Hoch',
    },
    ecsp: {
        natural: {
            info_text: '',
            info_text_highlight_one: '',
            info_text_highlight_two: '',
            info_text_highlight_three: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            experience: {
                no_answer: '',
                financial_education: '',
                bonds_knowledge: '',
                bonds_investment_frequency: '',
                stocks_knowledge: '',
                stocks_investment_frequency: '',
                convertible_bonds_knowledge: '',
                convertible_bonds_investment_frequency: '',
            },
            risk: {
                no_answer: '',
                startup_investing: '',
                investments_outside_stock_market: '',
                subordinated_financial_instruments: '',
                profit_participation_certificate: '',
            },
        },
        legal: {
            info_text: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            risk: {
                most_startups: '',
                dividends: '',
                higher_interest_rates: '',
                secure_investment: '',
                stocks_bankrupt_company: '',
                good_long_term_investment: '',
                return_on_investment: '',
            },
        },
        investment_frequency: {
            less_than_5_times: '',
            more_than_5_times: '',
            no_answer: '',
        },
        investment_horizon: {
            two_years: '',
            up_to_5_years: '',
            more_than_5_years: '',
            no_answer: '',
        },
        startup_investing: {
            high_return_low_risk: '',
            loss: '',
            growth: '',
        },
        investments_outside_stock_market: {
            low_risk: '',
            high_risk: '',
            high_proportion: '',
        },
        subordinated_financial_instruments: {
            insolvency_quote: '',
            equal_with_other_creditors: '',
            lose_investment: '',
        },
        profit_participation_certificate: {
            participate_profits_losses: '',
            fixed_interest_amount: '',
            transfer_to_company: '',
        },
        investor_classification: {
            expert_investor_treatment: '',
            self_disclosure_explanation: '',
            self_disclosure: '',
            print: '',
            upload_self_disclosure: '',
        },
        financial_education: {
            professional_experience: '',
            relevant_degree: '',
            both: '',
            none: '',
        },
        investment_goals: {
            no_answer: '',
            sustainability: '',
            investment_goal: '',
            investment_horizon: '',
        },
        sustainability: {
            very_true: '',
            applies: '',
            does_not_apply: '',
            no_answer: '',
        },
        investment_goal: {
            wealth_building: '',
            speculative_investments: '',
            no_answer: '',
        },
        most_startups: {
            successful: '',
            fail: '',
        },
        dividends: {
            equity: '',
            debt_capital: '',
        },
        higher_interest_rates: {
            secure_investment: '',
            risk_investment: '',
        },
        secure_investment: {
            bond_brd: '',
            bond_us_treasury: '',
            vw_share: '',
        },
        stocks_bankrupt_company: {
            refund: '',
            loss: '',
        },
        good_long_term_investment: {
            company_investment_portfolio: '',
            scatter_investments: '',
        },
        return_on_investment: {
            less_than_5_years: '',
            more_than_5_years: '',
        },
        financial_situation: {
            calculate: '',
            no_value: 'N/A',
            net_worth: '',
            net_worth_tooltip: '',
            loss_bearing_capacity: '',
            loss_bearing_capacity_tooltip: '',
            annual_net_income: '',
            annual_net_income_tooltip: '',
            annual_financial_commitments: '',
            annual_financial_commitments_tooltip: '',
            calculation_of_net_worth: '',
            liquid_funds: '',
            liquid_funds_tooltip: '',
            info_text: '',
        },
    },
    legal_account: {
        company_profile: '',
        company_name: '',
        registration_number: '',
        legal_form: 'Rechtsform',
        registration_authority: 'Registrierungsbehörde',
        address: '',
        description: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        iban: '',
        bic: '',
        tax_number: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        investor_classification: '',
        risk: '',
        financial_situation: '',
        default_language: 'Standardsprache',
    },
    beneficial_owner: {
        country_of_birth: '',
        city_of_birth: '',
        country_of_residence: '',
        no_beneficial_owners: '',
        no_beneficial_owners_description: '',
        indirect_ownership: 'Bitte geben Sie den Namen der jeweiligen Gesellschaft im Fall indirekter Eigentümer an',
        remove: 'Entfernen',
    },
    highest_educational_attainment: {
        prefer_not_to_say: '',
        no_degree: '',
        secondary_school: '',
        junior_high_school: '',
        high_school_diploma: '',
        university: '',
    },
    investment_experience: {
        none: '',
        up_to_3_years: '',
        between_3_and_5_years: '',
        more_than_5_years: '',
    },
    average_investment_transaction: {
        none: '',
        up_to_5: '',
        between_5_and_10: '',
        over_10: '',
    },
    average_investment_amount: {
        up_to_3000_eur: '',
        between_3001_and_5000_eur: '',
        between_5001_and_10000_eur: '',
        over_10000_eur: '',
    },
    validation_error: {
        required: '',
        email: '',
        invalid: '',
        countryISO3166: '',
        iban: '',
        bic: '',
        new_email_not_equals_old: '',
        wrong_date_format: '',
        date_min: '',
        date_max: '',
        min_age: '',
        max_age: '',
        min_amount: '',
        min_amount_on_wallet: '',
        max_amount: '',
    },
    account_settings: {
        dashboard: '',
        personal_data: '',
        personal_data_headline: '',
        address_data: '',
        address_data_headline: '',
        address_data_subtitle: '',
        membership_management: 'Mitgliedsbereich',
        nyala_vault: '',
        nyala_vault_headline: '',
        nyala_vault_subtitle: '',
        postal_address_data: 'Ihre Postadresse',
        compliance_profile: '',
        compliance_profile_subtitle: '',
        contact_data: '',
        contact_data_headline: '',
        contact_data_subtitle: '',
        security: '',
        security_headline: '',
        security_subtitle: '',
        verification: '',
        verification_headline: '',
        verification_subtitle: '',
        bank_data: '',
        bank_data_headline: '',
        bank_data_subtitle: '',
        tax_residencies: 'Steuerresidenzen',
        tax_data: '',
        overview: '',
        profile_data: '',
        legal_information: '',
        edit: '',
        legal_information_subtitle: '',
        current_status: '',
        crypto_wallet: '',
        crypto_wallet_headline: '',
        signatures: '',
        signatures_headline: '',
        signatures_subtitle: '',
        referral_program: '',
        referral_program_headline: '',
        referral_program_notice: '',
        investment_targets: 'Investor Profil',
        investment_targets_subtitle:
            'Die Investitionshorizont repräsentiert Ihre grundlegende Bereitschaft, eine Investitionsdauer zu haben. ',
        financial_conditions: 'Finanzlage',
        experience_and_knowledge: 'Investitionserfahrung und Wissen',
        risk_tolerance: 'Risikobereitschaft',
        fatca_declaration: 'FATCA-Erklärung',
        acknowledgements: 'Bestätigungen',
        kyc_form: 'KYC-Formular',
        tax_situation: 'Steuerlage',
        investor_classification: '',
        experience: '',
        risk: '',
        investment_goals: '',
        financial_situation: '',
    },
    compliance_profile: {
        save_header: '',
        save_description: '',
        discard_header: '',
        discard_description: '',
        save_financial_data_header: '',
        save_financial_data_description: '',
        back_to_compliance_profile: '',
        status: 'Status: {status}',
        compliance_profile_complete_and_valid_description: 'Ihr Compliance-Profil ist vollständig und gültig.',
        compliance_profile_complete_and_invalid_description: 'Ihr Compliance-Profil ist vollständig, aber ungültig.',
        compliance_profile_incomplete_description: 'Ihr Compliance-Profil ist unvollständig.',
        complete: 'Vollständig',
        incomplete: 'Unvollständig',
        complete_data: 'Vollständiges Compliance-Profil',
        complete_data_description: 'Bitte füllen Sie die Daten in Ihrem Compliance-Profil aus, um fortzufahren.',
        show_document: 'Dokument anzeigen',
        upload_document: 'Neues Dokument hochladen',
        edit_data: '',
        discard_data: '',
    },
    signatures: {
        complete_data_description_for_signatures: '',
        complete_compliance_profile: 'Vollständiges Compliance-Profil',
        sign_document: '',
        sign_documents: '',
        not_signed: '',
        signed: '',
        no_signatures: '',
        no_signatures_description: '',
        pending_signatures: '',
        pending_signatures_description: '',
        show_document: '',
        dialog_close_button: '',
        regenerate_signatures: '',
        regenerate_signatures_notice: '',
        print: '',
    },
    account_settings_legal: {
        dashboard: '',
        company_data: '',
        overview: '',
        address_data: '',
        bank_data: '',
        tax_data: '',
        verification: '',
        verification_kyc_documents_subtitle: '',
        manager_area: '',
        manager_area_subtitle: '',
        beneficial_owners: '',
        beneficial_owners_subtitle: '',
        investment_objectives: 'Gesellschafts-Investitionsprofil',
        financial_conditions: 'Gesellschafts-Finanzlage',
        risk_tolerance: 'Gesellschafts-Risikobereitschaft',
        tax_situation: 'Steuerinformationen',
        crs_classification: 'CRS-Klassifizierung',
        acknowledgements: 'Bestätigungen',
    },
    legal_account_manager_beneficial_owner: {
        beneficial_owner: 'Wirtschaftlich Berechtigter',
        manager: 'Manager',
        postal_address: 'Postadresse',
        no_beneficial_owners: 'Keine weiteren wirtschaftlich Berechtigten hinzugefügt',
    },
    legal_account_beneficial_owners: {
        add_beneficial_owner: '',
        manager: '',
    },
    legal_account_managers: {
        beneficial_owner: '',
        add_manager: '',
        manager_invited_notice: '',
        pending_invitations: '',
        dialogs: {
            failure_title: '',
            failure_message: '',
            failure_button: '',
            success_title: '',
            success_message: '',
            success_button: '',
            registration_required_title: '',
            registration_required_message: '',
            registration_required_button: '',
            already_accepted_title: '',
            already_accepted_message: '',
            already_accepted_button: '',
            legal_account_already_exists_title: '',
            legal_account_already_exists_message: '',
            legal_account_already_exists_button: '',
        },
    },
    account_links: {
        heading: '',
        orders: '',
        wallet: '',
    },
    referral_program: {
        your_referral_link: '',
        your_referral_code: '',
        generate_referral_code: '',
        generate_referral_code_description: '',
        generated_referral_code_successfully_message: '',
        generated_referral_code_error_message: '',
        referral_link_social_media_sharing: '',
        referral_info_title: '',
        referral_info_message: '',
        referral_existing_user_title: '',
        referral_existing_user_message: '',
        referral_campaign_not_found_title: '',
        referral_campaign_not_found_message: '',
        referral_success_custom_event_title: '',
        referral_success_custom_event_message: '',
        referral_success_redemption_event_title: '',
        referral_success_redemption_event_message: '',
    },
    verification: {
        pdf_both_sides: 'PDF (mit beiden Seiten)',
        upload_id_pdf: 'Klicken Sie hier, um die Datei hochzuladen (PDF)',
        upload_id_image: 'Klicken Sie hier, um die Datei hochzuladen (JPG, PNG, JPEG)',
        upload_id_pdf_and_image: 'Klicken Sie hier, um die Datei hochzuladen (PDF und JPG, PNG, JPEG)',
        identity_verification: '',
        identity_verification_subheadline: '',
        identity_verification_upload_notice: '',
        tax_verification: '',
        bank_verification: '',
        bank_verification_headline: '',
        address_verification: '',
        address_verification_headline: '',
        address_verification_subheadline: '',
        legal_verification: '',
        legal_verification_subheadline: '',
        legal_bank_verification: '',
        legal_bank_verification_subheadline: '',
        upload_label: '',
        upload_invalid_field: '',
        upload_waiting_for_size: '',
        upload_size_not_available: '',
        upload_loading: '',
        upload_load_error: '',
        upload_processing: '',
        upload_processing_complete: '',
        upload_processing_aborted: '',
        upload_processing_error: '',
        upload_processing_revert_error: '',
        upload_file_remove_error: '',
        upload_tap_to_cancel: '',
        upload_tap_to_retry: '',
        upload_tap_to_undo: '',
        upload_button_remove_item: '',
        upload_button_abort_item_load: '',
        upload_button_retry_item_load: '',
        upload_button_abort_item_processing: '',
        upload_button_undo_item_processing: '',
        upload_button_retry_item_processing: '',
        upload_button_process_item: '',
        tax_verification_headline: '',
        complete_data: '',
        complete_data_description: '',
        complete_data_description_for_verification: '',
        complete_data_description_short: '',
        complete_verification_outstanding: '',
        complete_verification_complete: '',
        completed_data: '',
        completed_data_description: '',
        complete_data_action_button: '',
        kyc_process: '',
        kyc_process_description: '',
        kyc_process_action_button: '',
        old_value: '',
        no_changes: 'Alle Daten entsprechen den zuvor angegebenen.',
        save: 'Speichern',
        new_value: '',
        override_data: '',
        override_data_description: '',
        verification_successful: '',
        verification_successful_description: '',
        status_not_started: '',
        status_not_started_description: '',
        status_created: '',
        status_created_description: '',
        status_in_review: '',
        status_in_review_description: '',
        status_data_changed: '',
        status_data_changed_description: '',
        status_success: '',
        status_success_description: '',
        status_failure: '',
        status_failure_description: '',
        id_now_kyc_continue_button: '',
        id_now_kyc_waiting_for_id_now_button: '',
        id_now_kyc_restart_button: '',
        id_now_kyc_start_button: '',
        ecsp_status_rejected: 'Nicht kundig - abgelehnt',
        ecsp_status_pending: 'Nicht kundig - Prüfung ausstehend',
        ecsp_status_expert: 'Kundig',
        ecsp_status_non_expert: 'Nicht kundig',
        signteq_kyc_start_button: 'KYC Verifizierung starten',
        signteq_kyc_restart_button: 'KYC Prozess erneut starten',
        schedule_kyc_support:
            'Wenn Sie Probleme beim Abschluss des KYC-Prozesses haben, wenden Sie sich bitte von hier aus an den Support:',
        schedule_kyc_contact_support_button: 'Kontaktieren Sie den Support',
    },
    verification_kyc_document: {
        show_details_button: '',
        hide_details_button: '',
        uploaded_at: '',
        comment: '',
        valid_to: '',
        verified_at: '',
        add_new_document: '',
        identification_type: '',
        in_progress: '',
        in_progress_description: '',
        on_hold: '',
        on_hold_description: '',
        accepted: '',
        accepted_description: '',
        accepted_not_eligible_for_withdrawal_description: '',
        accepted_not_eligible_for_withdrawal_description_re_upload: '',
        accepted_not_eligible_for_withdrawal_description_contact_support: '',
        rejected: '',
        rejected_description: '',
        unreadable: '',
        unreadable_description: '',
        expired: '',
        expired_description: '',
        wrong_type: '',
        wrong_type_description: '',
        wrong_name: '',
        wrong_name_description: '',
        duplicate_document: '',
        duplicate_document_description: '',
        type: {
            'passport': '',
            'invoice': '',
            'id-card': '',
            'residence-confirmation': '',
            'bank-statement': '',
            'sdd-mandate': '',
            'company-registration': '',
            'articles-of-association': '',
            'other': '',
        },
    },
    crypto_wallet: {
        request_wallet_button: '',
        notice: '',
        complete_verification_description_for_crypto_wallet: '',
        complete_data_description_for_crypto_wallet: '',
        success_dialog_title: '',
        success_dialog_description: '',
        success_dialog_button: '',
        error_dialog_title: '',
        error_dialog_description: '',
        error_dialog_button: '',
    },
    nyala_vault: {
        pin_info: '',
        reset_pin: '',
        invalid_pin: '',
        enter_a_valid_pin: '',
        reset_initiated_info: '',
        generate_random_pin: '',
        invalid_nyala_pin: '',
        nyala_new_pin: '',
        nyala_confirm_pin: '',
        explorer: '',
        explorer_link: '',
        confirm_pin: '',
        enter_confirm_pin: '',
        pin_confirmed: '',
        nyala_vault_not_created: '',
        vault_not_created_yet_at_nyala: '',
        nyala_passphrase_verification_success_title: '',
        nyala_passphrase_verification_success_message: '',
        nyala_passphrase_verification_expired_link_title: '',
        nyala_passphrase_verification_expired_link_message: '',
        invalid_link: 'Der Link ist nicht mehr gültig!',
    },
    bank_data: {
        iban_from_bank_account_notice: '',
        iban_from_bank_account_link_button: '',
        set_bank_data_from_profile: '',
    },
    bank_account: {
        bank_accounts: '',
        holder: '',
        iban: '',
        status: '',
        is_main: '',
        empty_state_header: '',
        empty_state_description: '',
        main_bank_account: '',
        set_as_main_bank_account: '',
        set_as_main_bank_account_success_message: '',
        in_progress: '',
        accepted: '',
        rejected: '',
        expired: '',
    },
    membership_document: {
        status: {
            accepted: 'Akzeptiert',
            pending: 'Ausstehend',
            rejected: 'Abgeleht',
        },
    },
    wallet: {
        my_wallets: 'Meine Wallets',
        my_wallets_subtitle: 'Übersicht meiner Wallets',
        vouchers: 'Vouchers',
        deposit: 'Aufladen',
        withdraw: 'Auszahlen',
        secupay: 'Secupay',
        secupay_amount_info_text: 'Nur Zahlungsanbieter, \n Kein Guthaben zu zeigen',
        lemonway: 'Lemonway',
        type: 'Wallet-Typ',
        no_transactions: 'Keine Transaktionen gefunden',
        secupay_verification_not_supported: 'Sie können die Bankverifizierung nicht mit dem Secupay Wallet durchführen',
        account_holder: '',
        payment_reference: '',
        payment_amount: '',
        accept_terms: '',
        accept_terms_link: '',
        my_wallet: '',
        my_wallet_subtitle: '',
        legal_wallet: '',
        legal_wallet_subtitle: '',
        no_wallet: '',
        no_wallet_description: '',
        current_balance: '',
        retrievable_balance: '',
        voucher_balance: '',
        withdrawal_button: '',
        withdrawal_header: '',
        withdrawal_description: '',
        verify_bank_account_alert_header: '',
        verify_bank_account_alert_description: '',
        verify_bank_account_alert_action_button: '',
        verify_wallet_alert_header: '',
        verify_wallet_alert_description: '',
        verify_wallet_alert_action_button: '',
        deposit_header: '',
        deposit_via_bank_transfer_header: '',
        deposit_via_bank_transfer_description: '',
        deposit_button: '',
        deposit_description: '',
        withdrawal_button_submit: '',
        deposit_button_submit: '',
        transaction_history: '',
        transaction_history_subtitle: '',
        transaction_history_export_button: '',
        transaction_date: '',
        transaction_title: '',
        transaction_payment_method: '',
        transaction_amount: '',
        edit_profile: '',
        withdrawal_pending_heading: '',
        withdrawal_amount: '',
        withdrawal_account_description: '',
        deposit_amount: '',
        confirm_withdrawal_title: '',
        confirm_withdrawal_description: '',
        cancel_wallet_withdrawal_confirm_heading: '',
        cancel_wallet_withdrawal_confirm_description: '',
        cancel_wallet_withdrawal: '',
        cancel_wallet_withdrawal_success: '',
        cancel_wallet_withdrawal_error: '',
        withdrawal_bank_account: '',
        withdrawal_bank_account_select: '',
        payment_options: {
            bank_transfer: '',
            credit_card: '',
        },
        lw_trasaction_type: {
            0: '',
            1: '',
            2: '',
        },
        lw_trasaction_method: {
            0: '',
            1: '',
            4: '',
            3: '',
            13: '',
            14: '',
            15: '',
            16: '',
            17: '',
            18: '',
            19: '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: '',
            25: '',
            26: '',
            27: '',
            28: '',
            29: '',
        },
        dialogs: {
            money_withdrawal_verification_expired_link_title: '',
            money_withdrawal_verification_expired_link_message: '',
            money_withdrawal_verification_no_longer_pending_title: '',
            money_withdrawal_verification_no_longer_pending_message: '',
            money_withdrawal_verification_success_title: '',
            money_withdrawal_verification_success_message: '',
            money_deposit_successful_title: '',
            money_deposit_successful_description: '',
            money_deposit_canceled_title: '',
            money_deposit_canceled_description: '',
            money_deposit_error_title: '',
            money_deposit_error_description: '',
            success_button: '',
            failure_button: '',
        },
    },
    voucher: {
        balance: '',
    },
    table: {
        pagination_results_overview: '',
        next: '',
        previous: '',
    },
    pending_investment_process: {
        title: '',
        description: '',
        resume_button: '',
        cancel_button: '',
    },
    texts: {
        email_change_notice: '',
        required: '',
        required2: '',
    },
    widget: {
        save: 'Speichern + Weiter',
        back: 'Zurück',
        sign_up_as: 'Ich bin ein',
        natural_person: 'Natürliche Person',
        legal_entity: 'Rechtsform',
        step_counter: 'Schritt {currentStep} von {totalSteps}',
        close: 'Abbrechen',
    },
    esac_widget_sidebar: {
        // prettier-ignore
        natural_legal_select:
            '<p>Willkommen beim KYC-Assistenten für die Investmentplattform des European Super Angels Club. Sobald Sie den KYC-Prozess abgeschlossen haben (einschließlich Hochladen der erforderlichen Dokumente und Genehmigung durch Venionaire Ventures), haben Sie Zugang zu allen Investitionen auf dieser Plattform und können in verschiedene Chancen investieren.</p>' +
            '<p>Wenn Sie Fragen zum KYC-Prozess haben oder Unterstützung benötigen, wenden Sie sich bitte an unser Support-Team unter <a href="mailto:platform@superangels.club">platform@superangels.club</a>.</p>' +
            '<p>Dieser Prozess dauert etwa 5 Minuten für natürliche Personen und 10–15 Minuten für juristische Personen.</p>' +
            '<p>Sie benötigen folgende Informationen:</p>' +
            '<p><strong>Natürliche Person:</strong><br>' +
            '<ul><li>Steuerinformationen</li></ul></p>' +
            '<p><strong>Juristische Person:</strong><br>' +
            '<ul><li>Steuerinformationen</li>' +
            '<li>CRS- und FATCA-Klassifizierungen</li>' +
            '<li>Informationen zur Investmenterfahrung des zweiten vertretungsberechtigten Zeichnungsberechtigten (falls zutreffend)</li></ul></p>',
        natural_personal_data: 'Bitte füllen Sie Ihre persönlichen Daten aus.',
        natural_address_data:
            'Bitte geben Sie Ihre Wohn- und Postadresse (falls unterschiedlich) an. Die Wohnadresse muss mit Ihrer Adressbestätigung übereinstimmen, die Sie später im KYC-Prozess hochladen.',
        natural_investment_targets:
            'Für Sie als Investor ist es wichtig, dass wir Ihre allgemeine Einstellung zur Art der Investition, Ihre Risikobereitschaft, Ihre Risikobereitschaft und Ihr Wissen kennen. Wir bitten Sie daher, dieses Formular wahrheitsgemäß auszufüllen.',
        financial_conditions:
            'Bitte füllen Sie die Informationen zur Ihrer Finanzlage aus. Wir müssen Ihre Risikobereitschaft in Bezug auf Ihre ungefähre Nettofinanzvermögen verstehen.',
        natural_experience_and_knowledge:
            'Bitte bestätigen Sie Ihr Wissen und Ihre praktische Investitionserfahrung in den aufgeführten Instrumenten.',
        natural_fatca: 'Bitte bestätigen Sie Ihren FATCA-Status.',
        natural_tax: 'Bitte bestätigen Sie Ihre Steuerlage und die Länder, in denen Sie Steuerresident sind.',
        acknowledgements:
            'Bitte lesen Sie sorgfältig und bestätigen Sie die bereitgestellten Aussagen. Diese werden elektronisch unterzeichnet auf den KYC-Formularen.',
        natural_kyc_form:
            'Herzlichen Glückwunsch, Sie haben den KYC-Assistenten erfolgreich abgeschlossen!\n' +
            ' Dieses Formular „Investor-Fragebogen” enthält alle Informationen und Bestätigungen, die Sie gerade gegeben haben. Bitte lesen Sie das Formular sorgfältig durch und unterzeichnen Sie es elektronisch. \n' +
            'Sie müssen auch Unterlagen hochladen, die Ihre Identität beweisen.\n' +
            'Das Formular und die Unterlagen werden dann von Venionaire Ventures überprüft, und sobald genehmigt, werden Sie benachrichtigt und können auf alle Investitionschancen auf dieser Plattform zugreifen. Wir werden uns bei Fragen bei Ihnen melden.<br><br>' +
            'Wenn eine elektronische Unterzeichnung nicht möglich ist, bitte drucken Sie das Vertragspapier aus, unterzeichnen Sie die Hardcopy und senden Sie es an:<br><br>' +
            'Venionaire Capital AG<br>' +
            'Babenbergerstraße 9/12<br>' +
            'A-1010 Vienna, Austria (EU)',
        legal_company_information:
            'Bitte geben Sie Registrierungsinformationen zur investierenden Gesellschaft (hierinafter „Investor“ oder „Entity“) an. \n' +
            'Bitte beachten Sie, dass in diesem Assistenten Managing Directors („MD“) als die vertretungsberechtigten Zeichnungsberechtigten des Investors definiert werden; Ultimate Beneficial Owners („UBO“) besitzen oder kontrollieren ein Interesse am Investor (rechtliche Person). \n' +
            'Bitte fügen Sie alle UBO hinzu, die 20% oder mehr des Stammkapitals und/oder der Stimmrechte besitzen, sowie alle MDs, die zur vertretungsberechtigten Zeichnungsberechtigten des Investors und zur Entscheidung über eine potenzielle Investition erforderlich sind.',
        legal_address_information: 'Bitte geben Sie die registrierte Adresse der investierenden Gesellschaft ein.',
        legal_manager_one_personal:
            'Bitte füllen Sie Ihre persönlichen Daten aus und wählen Sie den Typ der Kontrolle.',
        legal_manager_two_personal:
            'Bitte füllen Sie die persönlichen Daten des jeweiligen MD oder UBO aus und wählen Sie den Typ der Kontrolle.',
        legal_managers_ubo_overview:
            'Bitte fügen Sie einen potenziellen Co-Managing Director (gemeinsame Vertretung der investierenden Rechtlichen Person) hinzu, sowie andere wirtschaftlich Berechtigte (Eigentum > 20%) der investierenden Rechtlichen Person (falls zutreffend).',
        legal_manager_one_address: 'Bitte füllen Sie Ihre Adresse aus.',
        legal_manager_two_address: 'Bitte füllen Sie die Wohnadresse des jeweiligen MD oder UBO aus.',
        legal_manager_one_tax: 'Bitte füllen Sie Ihre Steuer- und Eigentumsinformationen aus',
        legal_manager_two_tax:
            'Bitte füllen Sie die Steuer- und Eigentumsinformationen des jeweiligen MD oder UBO aus.',
        // prettier-ignore
        legal_entity_investment_profile:
            'Es ist wichtig, dass wir die allgemeine Einstellung des Investors zur Art der Investition, seiner Risikobereitschaft, seiner Risikobereitschaft und seines Wissens kennen. Wir bitten Sie daher, diesen Abschnitt für den Investor wahrheitsgemäß auszufüllen.',
        legal_entity_financial_position:
            'Bitte füllen Sie diese Informationen zur Finanzlage der Gesellschaft aus. Dies ist, um die Risikobereitschaft der Gesellschaft in Bezug auf ihre ungefähre Nettofinanzvermögen zu verstehen.',
        legal_manager_one_experience_and_knowledge:
            'Bitte geben Sie Ihre persönliche Erfahrung und Ihr Wissen in den angegebenen Vermögensklassen sowie Finanzmärkten an. Bitte füllen Sie dies persönlich als MD (und nicht für die investierende Rechtliche Person) aus.',
        legal_manager_two_experience_and_knowledge:
            'Bitte geben Sie MD 2’s persönliche Erfahrung und ihr Wissen in den angegebenen Vermögensklassen sowie Finanzmärkten an.',
        legal_manager_two_authorization:
            'Bitte füllen Sie MD 2’s Investitionserfahrung und Wissen mit ihrer Genehmigung aus. Dies wird in einem KYC-Formular enthalten, das von beiden Managers unterzeichnet wird.',
        legal_entity_fatca:
            'Die Informationen in diesem Abschnitt dienen FATCA-Zwecken. Bitte beachten Sie, dass diese Klassifizierung möglicherweise von Ihrer CRS-Klassifizierung abweicht.',
        legal_entity_tax_situation:
            'Bitte bestätigen Sie die Steuerlage der Gesellschaft und die Länder, in denen sie Steuerresident ist.',
        legal_entity_crs: 'Bitte wählen Sie die CRS-Klassifizierung der Gesellschaft:',
        legal_acknowledgements:
            'Bitte lesen Sie sorgfältig und bestätigen Sie die bereitgestellten Aussagen. Diese werden elektronisch unterzeichnet auf den KYC-Formularen.',
        legal_beneficial_owner:
            'Bitte füllen Sie die persönlichen Daten des jeweiligen wirtschaftlich Berechtigten aus.',
        legal_kyc_form:
            'Vielen Dank für das Abschließen des KYC-Assistenten! Das Formular „ESAC Rechtliche Person” enthält alle Informationen und Bestätigungen, die Sie gerade gegeben haben. Bitte lesen Sie das Formular sorgfältig durch und unterzeichnen Sie es elektronisch. Wenn Sie einen zweiten erforderlichen Zeichnungsberechtigten (MD 2) haben, ist er/sie auch verpflichtet, dieses Formular zu unterzeichnen. Die teilweise vorbereiteten Dokumente („ESAC Rechtliche UBO für ...”) müssen von den jeweiligen wirtschaftlich Berechtigten ausgefüllt und unterzeichnet werden. Die vollständig ausgefüllten und unterzeichneten Dokumente müssen auf der Unternehmenskonto-Seite auf der Plattform hochgeladen werden (wählen Sie Ihr Profil in der oberen rechten Ecke, dann Unternehmenskonto und Unterzeichnungen in der unteren linken Ecke). \n' +
            'Die Formulare und Dokumente werden dann von Venionaire Ventures überprüft, und sobald genehmigt, werden Sie benachrichtigt und können auf alle Investitionschancen auf dieser Plattform zugreifen. Wir werden uns bei Fragen bei Ihnen melden.',
    },
    security: {
        password: {
            title: '',
            hint: '',
            update: '',
        },
        two_factor_authentication: {
            title: '',
            hint: '',
            configure: '',
            list_title: '',
            type: '',
            types: {
                otp: '',
                sms: '',
                passkey: '',
            },
            user_label: '',
            date: '',
            action: '',
            remove: '',
            non_removeable: '',
            remove_success: '',
        },
        dialogs: {
            error_title: '',
            error_message: '',
            success_title: '',
            success_message: '',
        },
        external_security_link: {
            title: '',
            hint: '',
            redirect: '',
        },
    },
    dialog: {
        button: {
            confirm: '',
            cancel: '',
            back: '',
            close: '',
            ok: '',
        },
        formDirty: {
            title: '',
            text: '',
            confirm: '',
            cancel: '',
        },
        formInvalid: {
            title: '',
            text: '',
        },
        iframe_link_notice: '',
        iframe_link_notice_link: '',
    },
    yes_no_deny: {
        yes: '',
        no: '',
        no_answer: '',
    },
    camera: {
        click_here_to_capture_image: 'Klicken Sie hier, um ein Foto zu machen',
        close: 'Kamera schließen',
        or: 'oder',
    },
    id_front: 'Vorderseite',
    id_back: 'Rückseite',
    newsletter_verification_success: 'Ihre E-Mail Newsletter-abo wurde erfolgreich bestätigt!',
}
